import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import i18n from '@/configs/i18n'
import { TourProvider } from '@/components/TourProvider'
import createTour from './components/Create/Tour'
const Create = lazy(() => import('./components/Create'))

const List = lazy(() => import('./components/List'))
const Update = lazy(() => import('./components/Update'))

const ResumeModule: RouteObject = {
    path: 'resume',
    children: [
        {
            path: '',
            children: [
                {
                    path: '',
                    element: <List />,
                },
                {
                    path: 'new',
                    element: (
                        <TourProvider steps={createTour(i18n.t)}>
                            <Create />
                        </TourProvider>
                    ),
                },
                {
                    path: ':cvID',
                    element: <Update />,
                },
            ],
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ResumeModule
